/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Server_Trainer_Reply_BodyInputs */

const en_us2_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to read the answer.`)
};

const pt_br2_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para ler a resposta.`)
};

const es_419_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para leer la respuesta.`)
};

const pt_pt2_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca para leres a resposta.`)
};

const fr_fr2_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touche pour lire la réponse.`)
};

const de_de2_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe, um die Antwort zu lesen.`)
};

const it_it2_push_server_trainer_reply_body = /** @type {(inputs: Push_Server_Trainer_Reply_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per leggere la risposta.`)
};

/**
* | output |
* | --- |
* | "Tap to read the answer." |
*
* @param {Push_Server_Trainer_Reply_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_server_trainer_reply_body = /** @type {((inputs?: Push_Server_Trainer_Reply_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Server_Trainer_Reply_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_server_trainer_reply_body(inputs)
	if (locale === "es-419") return es_419_push_server_trainer_reply_body(inputs)
	if (locale === "pt-PT") return pt_pt2_push_server_trainer_reply_body(inputs)
	if (locale === "fr-FR") return fr_fr2_push_server_trainer_reply_body(inputs)
	if (locale === "de-DE") return de_de2_push_server_trainer_reply_body(inputs)
	if (locale === "it-IT") return it_it2_push_server_trainer_reply_body(inputs)
	return en_us2_push_server_trainer_reply_body(inputs)
});
export { push_server_trainer_reply_body as "push-server.trainer_reply_body" }